import { useCustomDispatch } from "../../../../hooks";
import * as storage from "../../../../state/storage";
import { PlusIcon, SaveIcon, TrashIcon } from "../icons";
import Item from "./item";

interface Properties {
  label?: string;
}

const Menu: React.FC<Properties> = ({ label }) => {
  const dispatch = useCustomDispatch();

  const handleSave = () => {
    dispatch(storage.actions.save(label ?? "current"));
    dispatch(storage.actions.save("current"));
  };

  console.log(label);

  const handleAdd = () => {
    dispatch(
      storage.actions.save(
        !label || label === "current" ? `untitled-${Date.now()}` : label
      )
    );
    dispatch(storage.actions.empty());
  };

  const handleEmptying = () => {
    dispatch(storage.actions.empty());
    dispatch(storage.actions.append("uwu"));
  };

  return (
    <ul className="flex mx-6 mb-4 gap-4">
      <Item
        className="bg-pink-300 cursor-pointer"
        onClick={handleSave}
        children={<SaveIcon />}
      />
      <Item
        className="bg-blue-300 cursor-pointer"
        onClick={handleAdd}
        children={<PlusIcon />}
      />
      <Item
        className="bg-gray-300 cursor-pointer"
        onClick={handleEmptying}
        children={<TrashIcon />}
      />
    </ul>
  );
};

export default Menu;
